var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{class:['cp-gpay-pop', _vm.classStyle]},[(_vm.typeStyle === 'xx')?_c('p',{staticClass:"cp-gpay-pop_xx-title"}):_vm._e(),_vm._v(" "),_c('i',{staticClass:"cp-gpay-close",on:{"click":_vm.close}}),_vm._v(" "),_c('div',{staticClass:"cp-gpay-iframe"},[_c('iframe',{attrs:{"src":_vm.gpayUrl}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }